export const EL_ID_MH = 'medicalHistory';
export const PAST_VISIT_VITALS = 'past-visit-vitals';
export const EL_ID_VITALS = 'vitals';
export const MEDICAL_RECORDS = 'medical-records';
